import React from "react";
import { Col } from "antd";
import {
  HistoryIcon,
  HomeIcon,
  MenuBarSvg,
  ProfileIcon,
  WalletIcon,
  XboxIcon
} from "../../lib/svg_help";


const Footer = ({ selectedTab, setSelectedTab, colors }) => {
  const tabItems = [
    {
      key: "home",
      label: "Home",
      icon: <HomeIcon colors={colors} />,
    },
    {
      key: "wallet",
      label: "Wallet",
      icon: <WalletIcon colors={colors} />,
    },
    {
      key: "history",
      label: "History",
      icon: <HistoryIcon colors={colors} />,
    },
    {
      key: "profile",
      label: "Profile",
      icon: <ProfileIcon colors={colors} />,
    },
  ];

  return (
    <div style={{ position: "relative" }}>
      <MenuBarSvg
        colors={colors}
        style={{ width: "100%", objectFit: "cover" }}
      />

      <div
        style={{
          position: "absolute",
          top: 0,
          left: "50%",
          transform: "translate(-50%, -60%)",
          width: 50,
          height: 50,
          borderRadius: "50%",
          border: `2px solid ${colors.primary}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: colors.background
        }}
      >
        <XboxIcon colors={colors}/>
      </div>

      <div
        className="menu"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          
        }}
      >
        {tabItems.map((item) => (
          <Col
            key={item.key}
            style={{
              textAlign: "center",
              
              cursor: "pointer",
              opacity: selectedTab === item.key ? 1 : 0.6,
              transition: "opacity 0.3s ease",
            }}
            onClick={() => setSelectedTab(item.key)}
          >
            <div>
              {React.cloneElement(item.icon, {
                colors: {
                  primary: colors.primary,
                },
                style: {
                  opacity: selectedTab === item.key ? 1 : 0.6,
                },
              })}
            </div>
            <div
              style={{
                fontSize: 12,
                color: selectedTab === item.key ? colors.primary : colors.background,
              }}
            >
              {item.label}
            </div>
          </Col>
        ))}
      </div>
    </div>
  );
};

export default Footer;
